import React, { ReactNode } from 'react';

interface FuturisticSectionProps {
  variant?: 'primary' | 'secondary' | 'accent' | 'dark' | 'light';
  pattern?: 'grid' | 'dots' | 'none';
  glow?: boolean;
  waveTop?: boolean;
  waveBottom?: boolean;
  className?: string;
  children: ReactNode;
}

const FuturisticSection: React.FC<FuturisticSectionProps> = ({
  variant = 'light',
  pattern = 'none',
  glow = false,
  waveTop = false,
  waveBottom = false,
  className = '',
  children,
}) => {
  // All variants use the same neu-bg — depth comes from inner shadows
  const getBackgroundClasses = () => {
    switch (variant) {
      case 'primary':
        // Slightly inset feel for primary sections
        return 'bg-neu-bg';
      case 'secondary':
        return 'bg-neu-bg';
      case 'accent':
        return 'bg-neu-bg';
      case 'dark':
        return 'bg-neu-bg';
      default:
        return 'bg-neu-bg';
    }
  };

  return (
    <section
      className={[
        'relative py-12 md:py-16 overflow-hidden',
        getBackgroundClasses(),
        className,
      ].join(' ')}
    >
      {/* Subtle decorative concentric rings in the background */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden opacity-[0.03]">
        <div className="absolute -top-32 -right-32 w-[600px] h-[600px] rounded-full"
          style={{ boxShadow: '0 0 0 40px #3D4852' }} />
        <div className="absolute -bottom-48 -left-24 w-[400px] h-[400px] rounded-full"
          style={{ boxShadow: '0 0 0 30px #3D4852' }} />
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};

export default FuturisticSection;
